import { reconcileScaffoldItems } from "../reconcileScaffoldItems";
import { IScaffoldActionRowsChanged, ScaffoldState } from "./interface";

/**
 * Handles the ROWS_CHANGED action by reconciling the new rows against the previous snapshot,
 * updating enteringRowIds, leavingRows, and prevRows on the scaffold state.
 *
 * @param action - The ROWS_CHANGED action carrying the updated rows array.
 * @param state - The current scaffold state.
 * @returns Updated scaffold state reflecting the row changes, or the unchanged state if no ids changed.
 */
export const scr_rowsChanged = <T>(
  action: IScaffoldActionRowsChanged<T>,
  state: ScaffoldState<T>,
): ScaffoldState<T> => {
  const reconciliation = reconcileScaffoldItems(action.rows, state.prevRows, state.leavingRows);
  return !reconciliation.hasChanged
    ? state
    : {
        ...state,
        enteringRowIds: reconciliation.enteringIds,
        leavingRows: reconciliation.nextLeavingItems,
        prevRows: action.rows,
      };
};
